import React from 'react';

import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { Row, Col } from 'react-bootstrap';
import cn from 'classnames';
import Logo from '../event_components/logo';
import CheckoutController from '../event_components/Checkout';
import Title from '../event_components/title';
import Location from '../event_components/location';
import Time from '../event_components/time';
import Details from '../event_components/details';
import AttendButton from '../event_components/attend_button';
import styles from './list.scss';

import StackMobileLayout from './mobile-stack';
import MinimalLayout from './mobile-minimal';
import SideBySideMobileLayout from './mobile-side-by-side';
import GoogleLocation from '../event_components/google_location';
import EventStatus from '../event_components/event_status';
import AddEventToCalendar from '../event_components/add_to_calendar';
import { LocaleWrapper } from '../../locale-wrapper';
import PaginationContainer from './pagination_container';

export class ListCompressLayout extends React.Component {
  constructor() {
    super();
    this.state = {
      openTicketing: false,
    };
  }
  toggleAttendButton = () => {
    const { event } = this.props;

    if (event.get('type') === 'google') {
      return;
    }
    this.props.onResizeComponent();
    this.setState(
      {
        openTicketing: !this.state.openTicketing,
      },
      () => this.props.onResizeComponent()
    );
  };
  render() {
    const { event, settings, onResizeComponent } = this.props;
    const hasLogo = settings.get('showEventLogo');
    return (
      <div className={styles.container}>
        <CheckoutController
          variant="default"
          event={event}
          settings={settings}
          inClassName={cn('event-with-bottom-border')}
          openTicketing={this.state.openTicketing}
          onResizeComponent={onResizeComponent}
          onClose={() => {
            this.setState({
              openTicketing: false,
            });
          }}
        >
          <div className={cn(styles.list, 'event')}>
            <Row>
              {hasLogo && event.get('type') !== 'google' && event.get('type') !== 'zoom' && (
                <Col xs={5} md={4}>
                  <Time event={event} settings={settings} className={styles.time} withIcon />
                </Col>
              )}
              <Col xs={7} md={8} className={styles.details}>
                <Title event={event} settings={settings} />
              </Col>
            </Row>
            <Row>
              <Col xs={5} md={4}>
                <Logo event={event} settings={settings} className={styles.listCompressPhoto} />
              </Col>
              <Col xs={7} md={8} className={styles.details}>
                <div className={styles.listCompressDetails}>
                  {(settings.get('showVenue') || settings.get('showFullAddress')) && (
                    <>
                      {event.get('type') === 'google' ? (
                        <GoogleLocation event={event} />
                      ) : (
                        <Location event={event} className={`${styles.location} ${styles.left}`} settings={settings} />
                      )}
                    </>
                  )}
                  {settings.get('showEventStatus') && <EventStatus event={event} settings={settings} />}
                  {settings.get('enableAddToCalendar') && <AddEventToCalendar event={event} settings={settings} className={styles.addToCalendar} />}

                  <Details event={event} settings={settings} className={styles.description} onResizeComponent={onResizeComponent} />

                  <div>
                    <Row>
                      {!settings.get('removeAttendButton') && (
                        <Col xs={12} sm={12} md={6} lg={6} className={styles.noPadding}>
                          <AttendButton event={event} settings={settings} handleButtonClick={this.toggleAttendButton} />
                        </Col>
                      )}
                      <Col />
                    </Row>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </CheckoutController>
      </div>
    );
  }
}

const oldMobileLayoutComponent = (settings) => {
  const layoutDesign = settings.get('mobileLayoutDesign');

  const mapping = {
    stack: StackMobileLayout,
    sideBySide: SideBySideMobileLayout,
    minimal: MinimalLayout,
  };
  return mapping[layoutDesign] || StackMobileLayout;
};

function ListCompressContainer({ events, settings, isMobile, onResizeComponent }) {
  const Component = isMobile ? oldMobileLayoutComponent(settings) : ListCompressLayout;

  const renderEvent = (event) => (
    <LocaleWrapper event={event}>
      <Component key={event.get('id')} event={event} settings={settings} onResizeComponent={onResizeComponent} />
    </LocaleWrapper>
  );

  return <PaginationContainer events={events} settings={settings} onResizeComponent={onResizeComponent} renderEvent={renderEvent} />;
}

ListCompressContainer.propTypes = {
  events: PropTypes.instanceOf(Map).isRequired,
  settings: PropTypes.instanceOf(Map).isRequired,
  isMobile: PropTypes.bool,
};

export default ListCompressContainer;
